import { render, staticRenderFns } from "./ServiceInformation.vue?vue&type=template&id=485c7a30&scoped=true&"
import script from "./ServiceInformation.vue?vue&type=script&lang=js&"
export * from "./ServiceInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c7a30",
  null
  
)

export default component.exports